import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../common/mapYourMedsConstant.js';

const HcpSpecialityForm = (props) => {
    const initialFormData = {
        speciality: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);

    useEffect(() => {
        const val = props.specialityvalue || props.hcpsplvalue;
        if (val && (val.speciality_id || val.id)) {
            const { speciality, hcpspecial, is_active, speciality_id, id } = val;
            setFormData({
                speciality: speciality || hcpspecial || "",
                isactive: is_active == 1 || is_active === true,
                id: speciality_id || id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.specialityvalue, props.hcpsplvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");

        let pelmedsHcpSpecialityUrl = isAddMode 
            ? `${process.env.REACT_APP_SERVER_URL}/doctors/add-doctor-speciality` 
            : `${process.env.REACT_APP_SERVER_URL}/doctors/edit-doctor-speciality`;

        let pelmedsHcpSpecialityData = isAddMode 
            ? { "speciality": formData.speciality.trim(), "is_active": 1 } 
            : { "speciality": formData.speciality.trim(), "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        try {
            const { data } = await axios.post(pelmedsHcpSpecialityUrl, pelmedsHcpSpecialityData, { 
                headers: { 'Authorization': `Bearer ${tokenStr}` } 
            });

            if (data.status) {
                toast.success(isAddMode ? "HCP Speciality added successfully" : "HCP Speciality updated successfully");
            } else {
                toast.info(data.message || "Error while adding/updating HCP Speciality");
            }
        } catch (error) {
            console.error("Error submitting doctor speciality:", error);
            toast.error("Error submitting HCP Speciality");
        }

        setFormData(initialFormData);
        if (formRef.current) {
            formRef.current.reset();
        }
        setButtonStatus(mapYourMedsConstant.ADD_ACTION);

        if (props.onCallParent) {
            props.onCallParent();
        }
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">HCP Speciality</Form.Label>
                        <Form.Control
                            placeholder='HCP Speciality'
                            value={formData.speciality}
                            name="speciality"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            size="sm"
                            className="mt-4 w-50"
                            disabled={!formData.speciality || !formData.speciality.trim()}
                        >
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};

HcpSpecialityForm.propTypes = {
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func,
    specialityvalue: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    hcpsplvalue: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

export default HcpSpecialityForm;
